import { z } from 'zod';
import { ptBR } from 'zod/locales';

/** `z.config` altera estado global do `zod`: import por efeito colateral, o mais cedo possível em cada entry point (front e back empacotam cópias próprias). */
z.config(ptBR());
